export default "__VITE_ASSET__Bz5hdIKf__"